import React from 'react'
import { LuCircleAlert } from 'react-icons/lu'

import { Alert, AlertDescription } from '@/components/ui/alert'

interface Props {
  message?: React.ReactNode
}

const NotAllowedToViewContent: React.FC<Props> = ({
  message = <p>You do not have permission to view this content.</p>,
}) => (
  <Alert variant="warning">
    <LuCircleAlert />
    <AlertDescription>{message}</AlertDescription>
  </Alert>
)

export default NotAllowedToViewContent
